import { useState } from 'react'
import {
  Box,
  Stack,
  TextField,
  Typography,
  Button
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import DividerTAG from '../DividerTAG'
import { v4 as uuid4 } from 'uuid'
import CardTAG from '../CardTAG'
import FormLayout from '../forms/FormLayout'
import reportsSelectors from '../../store/reports/reportsSelectors'
import LabelErrorTAG from '../LabelErrorTAG'

import { 
  updateAnswerText,
  findItemByUuid
} from '../../store/reports/reportsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store'
import { IQuestionComponent } from './types'
import authSelectors from '../../store/auth/authSelectors'
import reporterConstants from '../../components/forms/ReportingPartyForm/constants'


const VictimFormQuestionComponent: React.FC<IQuestionComponent> = ({
  questionObj,
  question,
  questionUUID,
  questionId,
  questionOptions,
  control,
  fieldName,
  unregister,
  setValue,
  setAnswersFiles,
  answers = [],
  parent,
  previewOnly = false,
}) => {
  

  const userEditAccess = useSelector(authSelectors.userReportEditAccess)
  const dispatch = useDispatch<AppDispatch>()
  const getAnswer = () => {
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, questionUUID)
    }
    return useSelector(reportsSelectors.answersToCaseTypeQuestion(questionUUID))
  }
  const answer = getAnswer()

  const type = questionObj.type || 'RECIPIENT'

  let answerJson: any = answer?.answer.text.trim() ? JSON.parse(answer?.answer.text) : []
  

  const onChange = (e: any, id: string) => {
    const personIndex = answerJson.findIndex((person: any) => person.id === id)
    if (personIndex >= 0) {
      answerJson[personIndex][e.target.name] = e.target.value
      updateAnswer()
    }

  }

  const updateAnswer = () => {
    dispatch(
      updateAnswerText({
        answerUUID: answer?.uuid,
        answerText: JSON.stringify(answerJson),
        parentUUID: parent?.uuid,
        questionId
      }),
    )
  }

  const removePerson = (id: string) => {
    answerJson = answerJson.filter((person: any) => person.id !== id)
    updateAnswer()
  }

  const addPerson = () => {
    const newPerson: any = {}
    newPerson['id'] = uuid4()
    reporterConstants.textFieldBasedOnSubjectType[type].map(field => {
      newPerson[field.fieldName] = ''
    })
    answerJson.push(newPerson)
    updateAnswer()

  }
 

  return (
    <div id={`${questionId}`}>
      <CardTAG
        questionCard={true}
        color={`${previewOnly ? 'tagBoxArchive' : 'tagBoxSuccess'}`}
        title={
          <Box sx={{ wordWrap: 'break-word', whiteSpace: 'unset', textOverflow: 'unset' }}>
            <Typography
              variant='h4'
              sx={{
                wordWrap: 'break-word',
                overflow: 'hidden',
              }}
            >
              {question}
            </Typography>
          </Box>
        }
        
      >
        <FormLayout>
          {' '}
          <Button startIcon={<AddIcon />} variant='submitFormButton' onClick={addPerson}>
            <Typography variant='bodyBold'>Add Person</Typography>
          </Button>
          <DividerTAG />
        </FormLayout>

        {answerJson && answerJson.length > 0 && answerJson.map((person: any) => {
          return(
            <FormLayout key={person.id}>
              {' '}
              {reporterConstants.textFieldBasedOnSubjectType[type].map(field => {
                return (
                  <Stack key={field.fieldName}>
                    <LabelErrorTAG label={field.label} />
                    <TextField
                      value={person[field.fieldName]}
                      onChange={e => onChange(e, person.id)}
                      variant='standard'
                      type={'text'}
                      fullWidth
                      id={field.fieldName}
                      name={field.fieldName}
                      disabled={!userEditAccess || previewOnly}
                    />
                  </Stack>
                )
              })}
              <Button startIcon={<RemoveIcon />} variant='submitFormButton' onClick={() => removePerson(person.id)}>
                <Typography variant='bodyBold'>Remove Person</Typography>
              </Button>
              <DividerTAG />
            </FormLayout>
          )
        })}
        
        
        </CardTAG>
      </div>
  )
}

export default VictimFormQuestionComponent
